const API_URL = "https://student-backend-infs-202.onrender.com";

export const getStudents = async () => {
  const res = await fetch(`${API_URL}/students`);

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Failed to fetch students");
  }

  return data;
};